import {
  Picker,
  Input,
  RadioGroup,
  Select,
  Grid,
  Row,
  Button,
  Form,
  SelectForm
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { Control } from 'react-hook-form'
import { IGetAllItensSegurancaResponse } from 'services/GST/CadastroItensSubitensSeguranca'
import { SPACING } from 'utils'
import { TipoPendencia } from 'utils/types'
import { SearchParamsProps } from '../../Search'
import { Box } from '@mui/material'

interface ISearchFields {
  // documentTypes: IGetAllItensSegurancaResponse[]
  documentTypes: any
  control: Control<SearchParamsProps, any>
  errors: any
  handleSubmit: any
  handleSearch: (_form?: SearchParamsProps) => void
  handleReset: () => void
}

export const SearchFields = ({
  handleSubmit,
  handleSearch,
  handleReset,
  documentTypes,
  control,
  errors
}: ISearchFields) => {
  function handleSubmitForm(form?: SearchParamsProps) {
    handleSearch(form)
  }

  return (
    <Form onSubmit={handleSubmit(handleSubmitForm)}>
      <Grid
        gridCols="1fr 1fr 1fr 1fr 2fr 2fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Input
          label="Contrato"
          placeholder="Nº"
          // value={form?.CdContrato}
          control={control}
          formValue="CdContrato"
          maxLength={100}
          // onChange={onChange}
        />
        <SelectForm
          listOptions={documentTypes
            ?.map((doc: TipoPendencia) => ({
              label: doc?.txDescricao,
              value: doc?.idTipoPendencia
            }))
            .sort((a, b) => a?.label.localeCompare(b?.label))}
          label="Tipo Documento"
          placeholder="Selecione"
          control={control}
          formValue="TipoDoc"
          // value={form?.TipoDoc}
          // onChange={onChange}
          // clearSelect={true}
        />
        <SelectForm
          control={control}
          listOptions={[
            // { label: '', value: '' },
            { label: 'Aprovado', value: 'Aprovado' },
            { label: 'Pendente', value: 'Pendente' },
            { label: 'Analisar', value: 'Analisar' },
            { label: 'Recusado', value: 'Recusado' }
          ]}
          label="Status"
          placeholder="Selecione"
          formValue="Status"
          // value={form?.Status}
          // onChange={onChange}
          // clearSelect={true}
        />
        <Input
          control={control}
          label="Nome Fornecedor"
          placeholder="Nome Fornecedor"
          formValue="NmFornecedor"
          maxLength={100}
          // value={form?.NmFornecedor}
          // onChange={onChange}
        />
      </Grid>
      <Grid
        gridCols="1fr 1fr 1fr 1fr 1fr 1fr 2fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Picker
          label="Período Competência"
          type="monthAndYear"
          control={control}
          errors={errors}
          formValue="CompetenciaInicio"
          // maxDate={form?.CompetenciaFim || null}
          // value={form?.CompetenciaInicio}
          // onChange={(date) =>
          //   onChange({ target: { name: 'CompetenciaInicio', value: date } })
          // }
        />
        <Picker
          label="à"
          type="monthAndYear"
          control={control}
          errors={errors}
          formValue="CompetenciaFim"
          // minDate={form?.CompetenciaInicio || null}
          // value={form?.CompetenciaFim}
          // onChange={(date) =>
          //   onChange({ target: { name: 'CompetenciaFim', value: date } })
          // }
        />
        <Picker
          label="Período Data Anexada"
          control={control}
          errors={errors}
          formValue="DataAnexadaInicio"
          // maxDate={form?.DataAnexadaFim || null}
          // value={form?.DataAnexadaInicio}
          // onChange={(date) =>
          //   onChange({ target: { name: 'DataAnexadaInicio', value: date } })
          // }
        />
        <Picker
          label="à"
          control={control}
          errors={errors}
          formValue="DataAnexadaFim"
          // minDate={form?.DataAnexadaInicio || null}
          // value={form?.DataAnexadaFim}
          // onChange={(date) =>
          //   onChange({ target: { name: 'DataAnexadaFim', value: date } })
          // }
        />
      </Grid>
      <Row marginTop={SPACING.spacing20} justifyContent="space-between">
        <RadioGroup
          formValue="enumFilter"
          control={control}
          label=""
          row
          listOptions={[
            { label: 'Documentação Mensal', value: 0 },
            { label: 'Pendências', value: 1 },
            { label: 'Todos', value: 2 }
          ]}
          // onChange={onChange}
          // value={form?.enumFilter}
        />
        <Box>
          <Button
            text="Limpar"
            variantButton="text"
            marginRight={SPACING.spacing15}
            onClick={handleReset}
          />
          <Button
            type={'submit'}
            text="PESQUISAR"
            endIcon={<MagnifyingGlassIcon />}
          />
        </Box>
      </Row>
    </Form>
  )
}
